import React from 'react';

/** The single text input used across the entry flow. */
export function EntryField({
  label,
  value,
  onChange,
  type = 'text',
  hint,
  error,
  autoComplete,
  placeholder
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'password';
  hint?: string;
  error?: string;
  autoComplete?: string;
  placeholder?: string;
}) {
  const id = `entry-${label.replace(/\s+/g, '-').toLowerCase()}`;
  return <label htmlFor={id} className="block" data-id="element-743" data-mp="7rvtruca2w4a">
      <span className="bee-overline text-[8.5px] font-bold text-muted" data-id="element-744" data-mp="2yswbb4dr2it">{label}</span>
      <input id={id} type={type} value={value} placeholder={placeholder} autoComplete={autoComplete} onChange={event => onChange(event.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined} className={`mt-1 h-12 w-full rounded-card border bg-white px-2 text-[14px] text-deep placeholder:text-muted/70 focus:outline-none ${error ? 'border-ink' : 'border-sand-line focus:border-deep/40'}`} data-id="element-745" data-mp="3v2lmsylgbh48" />
      {error ? <span id={`${id}-error`} role="alert" className="mt-1 block text-[11.5px] leading-snug text-ink" data-id="element-746" data-mp="119l4v4blr33v">
          {error}
        </span> : hint && <span id={`${id}-hint`} className="mt-1 block text-[11.5px] text-muted" data-id="element-747" data-mp="1f7jgi1yjglfo">
            {hint}
          </span>}
    </label>;
}